export default "__VITE_ASSET__ugH1x7ol__"